import React from 'react';
import type {ReactElement} from 'react';
import {MobilePanelHeader} from '@Components/email-maker-block-manager/components/mobile-panel-header';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {useIsMobileScreen} from '@Components/email-maker-block-manager/email-maker-block-manager-grapesjs-editor-context';
import styles from '@Components/email-maker-block-manager/components/elements-panel-header/elements-panel-header.module.scss';

interface MobileElementsPanelHeaderProps {
  headerLabel: string | null;
  showBackButton?: boolean;
  onBackButton?: VoidFunction;
  showShadow?: boolean;
  className?: string;
}

export function ElementsPanelHeader({headerLabel = null, showBackButton = false, onBackButton, showShadow = false, className = ''}: MobileElementsPanelHeaderProps): ReactElement<any> | null {
  const isMobileScreen = useIsMobileScreen();

  const getPanelClasses = (): string => {
    return showBackButton ? `${styles.panelHeader} ${className} spacing-m-b-4` : '';
  };

  const getTextClasses = (): string => {
    return showBackButton ? 'spacing-m-l-1' : '';
  };

  const getBackButton = (): ReactElement<any> | null => {
    if (!showBackButton) {
      return null;
    }

    return <Icon icon="icon-arrow-left" className={styles.backIcon} size={IconSize.SIZE_ICON_16} onClick={onBackButton} type={IconType.GHOST} shape={IconShape.SQUARE} />;
  };

  if (!headerLabel) {
    return null;
  }

  if (isMobileScreen) {
    return (
      <div className={`${styles.mobilePanelHeader} ${showShadow ? styles.mobilePanelHeaderShadow : ''}`}>
        <MobilePanelHeader headerLabel={headerLabel} showHandleBar showBackButton={showBackButton} onBackButton={onBackButton} />
      </div>
    );
  }

  return (
    <div className={getPanelClasses()}>
      {getBackButton()}
      <Text val={headerLabel} className={getTextClasses()} size={TextSize.SMALL} bold />
    </div>
  );
}
